import { css } from 'aphrodite';
import type { IRevertSummary } from '../../../extViewmodels/sdk/models';
import { Button } from '../../../web/components-v2/Button';
import { THEME } from '../../../web/components-v2/Theme/theme';
import { DangerIcon } from '../../../web/components/svgs/icons/DangerIcon';
import { hasRevertWarnings } from '../RevertResultModal/utils';
import { styleSheet } from './styles';

interface Props {
	summary: IRevertSummary;
	onViewDetails(): void;
}

export function RevertSummaryRow({ summary, onViewDetails }: Props) {
	const warnings = hasRevertWarnings(summary);
	const stats: Array<{ count: number; label: string }> = [
		{ count: summary.contactsDeleted, label: 'archived' },
		{ count: summary.contactsRestored, label: 'restored' },
		{ count: summary.contactsMergedReverted, label: 'merges reversed' },
		{ count: summary.contactsSkippedModifiedSinceImport, label: 'skipped' },
		{ count: summary.contactsMergeRevertFailed, label: 'merge fails' },
	];
	const visible = stats.filter(s => s.count > 0);

	return (
		<div
			className={css(styleSheet.container)}
			role='status'
			aria-label={`Revert summary: ${visible.map(s => `${s.count} ${s.label}`).join(', ')}${warnings ? ', with warnings' : ''}`}
		>
			<span className={css(styleSheet.label)}>Reverted</span>
			{visible.map(stat => (
				<span key={stat.label} className={css(styleSheet.stat)}>
					<span className={css(styleSheet.statCount)}>{stat.count}</span> {stat.label}
				</span>
			))}
			{warnings && (
				<span className={css(styleSheet.warningIndicator)}>
					<DangerIcon
						backgroundColor={THEME.colors.danger.main}
						borderColor={THEME.colors.danger.main}
						className={css(styleSheet.warningIcon)}
					/>
					with warnings
				</span>
			)}
			<Button variant='link' size='sm' styles={[styleSheet.detailsButton]} onClick={onViewDetails}>
				View details
			</Button>
		</div>
	);
}
